module.exports = __webpack_public_path__ + "img/premium-badge.f134bd96.png";